import { useState } from 'react'

import { Label, Layout, Text, Textarea } from '@loadsmart/loadsmart-ui'

export type QuoteNotesProps = {
  initialNotes?: string
  disabled?: boolean
  onChange: (notesToShipper: string) => void
}

export function QuoteNotes({ initialNotes = '', disabled = false, onChange }: QuoteNotesProps) {
  const [notes, setNotes] = useState<string>(initialNotes)

  function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    setNotes(event.target.value)

    onChange(event.target.value)
  }

  return (
    <Layout.Stack space="xs">
      <Text variant="heading-sm-bold">Notes</Text>
      <Label htmlFor="shipper-notes">Add notes to Shipper</Label>
      <Textarea
        style={{
          resize: 'none',
        }}
        id="shipper-notes"
        name="shipper-notes"
        data-testid="shipper-notes"
        value={notes}
        placeholder="Insert here any notes related to this lane"
        onChange={handleChange}
        disabled={disabled}
      />
    </Layout.Stack>
  )
}
